<template>
  <div class="chat-list-container">
    <div
      v-for="item in chats"
      :key="item.chatId"
      class="chat-item"
      @click="openChat(item)"
    >
      <el-badge :value="item.unread" :max="99" :hidden="item.unread === 0" class="avatar-badge">
        <el-avatar :size="48" shape="square" :src="item.receiver.avatarUrl" />
      </el-badge>

      <div class="chat-info">
        <div class="chat-top">
          <span class="nickname">{{ item.receiver.screenName }}</span>
          <span class="time">{{ item.lastMessageTime }}</span>
        </div>
        <div class="chat-bottom">
          <span class="last-msg">{{ item.lastMessageContent }}</span>
          <i v-if="item.muted" class="el-icon-bell-off mute-icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChatDialogues } from '@/api/chat'

export default {
  name: 'ChatList',
  data() {
    return {
      chats: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getChatDialogues().then(resp => {
        if (resp.code === 0) {
          this.chats = resp.data
        }
      })
    },
    openChat(item) {
      this.$router.push({
        path: '/chat/dialogue',
        query: {
          chatId: item.chatId
        }
      })
    }
  }
}
</script>

<style scoped>
.chat-list-container {
  background-color: #fff;
}
.chat-item {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
  background-color: #fff;
}
.chat-item:active {
  background-color: #f5f5f5; /* 模拟点击态 */
}
.avatar-badge {
  flex-shrink: 0;
}
.chat-info {
  flex: 1;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}
.chat-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.nickname {
  font-size: 16px;
  color: #191919;
  font-weight: 500;
}
.time {
  font-size: 12px;
  color: #b2b2b2;
}
.chat-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.last-msg {
  font-size: 14px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
.mute-icon {
  font-size: 14px;
  color: #ccc;
  margin-left: 5px;
}
</style>
